$(function() {
  $('a[href="/logout"]').on('click', function() {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
  });

  if (location.pathname.includes('register-company')) {
    const userIdEl = document.getElementById('userId');
    const userId = userIdEl ? userIdEl.content : '';

    if (!!userId) {
      try {
        if (typeof window.ym === 'function') {
          window.ym(29709265, 'reachGoal', 'comp_cabinet_about_pageview', { user_id: userId });
        }
      } catch (_) {
      }
    }
  }

  if (location.pathname.includes('ftasks')) {
    const userIdEl = document.getElementById('userId');
    const userId = userIdEl ? userIdEl.content : '';

    if (!!userId) {
      try {
        if (typeof window.ym === 'function') {
          window.ym(29709265, 'reachGoal', 'comp_cabinet_tasks_pageview', { user_id: userId });
        }
      } catch (_) {
      }
    }
  }

  let loadingElements = [];

  function showSpinner(element) {
    if (loadingElements.includes(element)) {
      return false;
    }
    loadingElements.push(element);
    element.addClass('bg-white loading-bg');

    return true;
  }

  let pressedButtons = [];
  function showLoader(button, loader) {
    if (pressedButtons.includes(button)) {
      return false;
    }
    pressedButtons.push(button);
    button.prop('disabled', true);
    loader.addClass('bg-brand-primary dots-loading-bg');

    return true;
  }

  $('select.select2').each(function() {
    let $select = $(this),
      width = $select.attr('data-select-width') || '100%';

    $select.select2({ allowClear: true, width: width });

    $select.closest('.input-group').on('click', '.clear-field', function() {
      const $inputGroup = $(this).closest('.input-group');
      const $selectField = $inputGroup.find('select');
      const $hiddenField = $inputGroup.find('input[type="hidden"]');

      $selectField.val(null).trigger('change');

      if ($hiddenField.length) {
        $hiddenField.val('');
      }
    });

    $select.on('change', function() {
      const $inputGroup = $select.closest('.input-group');
      const $hiddenField = $inputGroup.find('input[type="hidden"]');

      if ($hiddenField.length) {
        $hiddenField.val($select.val());
      }
    });
  });
  $('.datepicker').each(function() {
    let elem = $(this);
    elem.datepicker({
      autoclose: true,
      zIndexOffset: 99999,
      format: elem.attr('data-date-dateformat') || 'dd.mm.yyyy',
      container: elem.attr('data-container') || 'body',
      startDate: elem.attr('data-start-date'),
      startView: getViewId(elem.attr('data-date-start-view') || 'days'),
      minViewMode: getViewId(elem.attr('data-date-min-view-mode') || 'days'),
      maxViewMode: getViewId(elem.attr('data-date-max-view-mode') || 'decade'),
      language: getLocale(),
      templates: {
        leftArrow: '<i class="fa fa-chevron-left"></i>',
        rightArrow: '<i class="fa fa-chevron-right"></i>'
      }
    });
  });

  function getLocale() {
    const localeMeta = document
      .querySelector('meta[name="language"]')
      .getAttribute('content');
    return localeMeta ? localeMeta : 'ru';
  }

  function getViewId(viewName) {
    switch (viewName) {
      case 'days':
      case 'month':
        return 0;
      case 'months':
      case 'year':
        return 1;
      case 'years':
      case 'decade':
        return 2;
      case 'decades':
      case 'century':
        return 3;
      default:
        return 0;
    }
  }

  $('.utc-datetime').each(function(_, el) {
    parseUTCDateTime(el);
  });
  $('.utc-date').each(function(_, el) {
    parseUTCDate(el);
  });

  $('.datetime').each(function(_, el) {
    parseDateTime(el);
  });
  $('.date').each(function(_, el) {
    parseDate(el);
  });

  let workingDate = false;
  let workingDateTime = false;
  let workingDateWithoutUTC = false;
  let workingDateTimeWithoutUTC = false;
  const observer = new MutationObserver(mutationList =>
      mutationList.filter(m => m.type === 'childList').forEach(m => {
        m.addedNodes.forEach(function() {
          if ($(".utc-date").not(".utc-done").length && !workingDate) {
            workingDate = true;
            $(".utc-date")
                .not(".utc-done")
                .each(function (_, el) {
                  parseUTCDate(el);
                })
                .promise()
                .done(() => (workingDate = false));
          }
          if ($(".utc-datetime").not(".utc-done").length && !workingDateTime) {
            workingDateTime = true;
            $(".utc-datetime")
                .not(".utc-done")
                .each(function (_, el) {
                  parseUTCDateTime(el);
                })
                .promise()
                .done(() => (workingDateTime = false));
          }
          if (
              $(".datetime").not(".datetime-done").length &&
              !workingDateTimeWithoutUTC
          ) {
            workingDateTimeWithoutUTC = true;
            $(".datetime")
                .not(".datetime-done")
                .each(function (_, el) {
                  parseDateTime(el);
                })
                .promise()
                .done(() => (workingDateTimeWithoutUTC = false));
          }
          if ($(".date").not(".date-done").length && !workingDateWithoutUTC) {
            workingDateWithoutUTC = true;
            $(".date")
                .not(".date-done")
                .each(function (_, el) {
                  parseDate(el);
                })
                .promise()
                .done(() => (workingDateWithoutUTC = false));
          }
        });
      }));
  observer.observe(document.body,{childList: true, subtree: true});

  function parseUTCDate(el) {
    const value = parseInt(el.innerHTML) * 1000;
    if (!isNaN(value)) {
      el.classList.add('utc-done');
      el.innerHTML = formatDate(value, true);
    }
  }

  function parseDate(el) {
    const value = parseInt(el.innerHTML) * 1000;
    if (!isNaN(value)) {
      el.classList.add('date-done');
      el.innerHTML = formatDate(value);
    }
  }

  function parseDateTime(el) {
    const value = parseInt(el.innerHTML) * 1000;
    if (!isNaN(value)) {
      el.classList.add('datetime-done');
      el.innerHTML = formatDateTime(value);
    }
  }

  function parseUTCDateTime(el) {
    const value = parseInt(el.innerHTML) * 1000;
    if (!isNaN(value)) {
      el.classList.add('utc-done');
      el.innerHTML = formatDateTime(value, true);
    }
  }

  function formatDate(date, withUTC = false) {
    const resLocalDate = new Date(date);
    const resUTCDate = new Date(
      new Date(date).setMinutes(
        resLocalDate.getMinutes() + resLocalDate.getTimezoneOffset()
      )
    );
    if (withUTC) {
      return `${getDateTime(resUTCDate, false)} UTC (${getDateTime(
        resLocalDate,
        false
      )} local time)`;
    }
    return getDateTime(resLocalDate, false);
  }

  function formatDateTime(date, withUTC = false) {
    const resLocalDate = new Date(date);
    const resUTCDate = new Date(
      new Date(date).setMinutes(
        resLocalDate.getMinutes() + resLocalDate.getTimezoneOffset()
      )
    );
    if (withUTC) {
      return `${getDateTime(resUTCDate)} UTC (${getDateTime(
        resLocalDate
      )} local time)`;
    }
    return getDateTime(resLocalDate);
  }

  function getDateTime(currentDate, withTime = true) {
    const date =
      currentDate.getDate() +
      '.' +
      ('0' + (currentDate.getMonth() + 1)).substr(-2) +
      '.' +
      currentDate.getFullYear();
    var currentHours = ("0" + currentDate.getHours()).substr(-2);
    var currentMins = ("0" + currentDate.getMinutes()).substr(-2);
    var time = currentHours + ":" + currentMins;
    var dateTime = withTime ? `${date} ${time}` : date;
    return dateTime;
  }

  function isValidDate(date) {
    return (
      date &&
      Object.prototype.toString.call(date) === "[object Date]" &&
      !isNaN(date)
    );
  }

  function viewWarningAlert(message) {
    $.smallBox({
      title: translate.payment_caption,
      content: message,
      color: "#C46A69",
      timeout: 1000,
      icon: "fa fa-warning shake animated",
    });
  }

  function viewWarningCommonAlert(message) {
    $.smallBox({
      title: translate.alert_danger_caption,
      content: message,
      color: "#C46A69",
      timeout: 1000,
      icon: "fa fa-warning shake animated",
    });
  }

  $('[data-toggle="popover-lg"]').popover({
    animation: true,
    trigger: 'hover',
    template:
      '<div class="popover popover-lg" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>',
  });

  $('[data-toggle="popover-notifications"]').popover({
    html: true,
    animation: true,
    placement: "right",
    template:
      '<div class="popover sr-popover-notifications" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>',
  });

  $('[data-toggle="popover-notifications"]').on(
    "shown.bs.popover",
    function () {
      Cookies.set("popover-notifications", $(this).attr("data-hash"));
    }
  );

  if (
    Cookies.get("popover-notifications") !=
      $('[data-toggle="popover-notifications"]').attr("data-hash") &&
    window.innerWidth > 980
  ) {
    $('[data-toggle="popover-notifications"]').popover("show");
  }

  if ($('[data-toggle="popover-notifications"]').data("isfreelancer") != "1") {
    setTimeout(function () {
      if (!Cookies.get("popover-notifications")) {
        $('[data-toggle="popover-notifications"]').popover("hide");
      }
    }, 10000);
  }

  $(document).on("click", function (e) {
    if (
      !$(e.target).is(
        $(
          '[data-toggle="popover-notifications"], [data-toggle="popover-notifications"] i, .menu-item-parent, .badge, .popover-title, .popover-content'
        )
      ) && (e.target.id !== 'confirmEmailLink') && (e.target.id !== 'confirmEmailLink_fail')) {
      $('[data-toggle="popover-notifications"]').popover("hide");
    } else if (e.target.id === 'confirmEmailLink' || e.target.id === 'confirmEmailLink_fail'){
      $('#confirmEmailLink').css('display', 'none');
      $('#confirmEmailLink_pending').css('display', 'block');
      $.ajax({
        url: "/api/profile/init-email-verification",
        type: "POST",
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('accessToken')
        },
      }).done(function (response) {
        $('#confirmEmailLink_pending').css('display', 'none');
        $('#confirmEmailLink_success').css('display', 'block');
      }).error(function (error) {
        $('#confirmEmailLink_pending').css('display', 'none');
        $('#confirmEmailLink_fail').css('display', 'block');
      });
    }
  });

  $(".with-accept").on("mousedown", function (event) {
    var that = $(this);
    $.SmartMessageBox(
      {
        title: "Изменение данных",
        content: "Вы уверены что хотите совершить это действие?",
        buttons: "[Нет][Да]",
      },
      function (ButtonPressed) {
        if (ButtonPressed === "Да") {
          that.click();
        }
      }
    );
  });


  changePage(location.hash);

  $(window).bind('hashchange', function(e) {
    changePage(location.hash);
  });

  function changePage(hash) {
    let id;

    if (hash !== '' && hash.substr(0, 1) !== '#') {
      hash = '#' + hash;
    }

    if (hash === '' || hash === '#') {
      id = '.why';
    } else {
      id = '.' + hash.substr(1);
    }

    if ($(id + '-block').length) {
      if ($('.viewed').length) {
        $('.viewed').fadeTo(300, 0, function() {
          $(this).hide(function() {
            $(id + '-block').fadeTo(300, 1, function() {
              $(this).show(100, function() {
                $(id + '-block').addClass('viewed');
              });
            });
          });
        });
      } else {
        $(id + '-block').fadeTo('slow', 1);
        $(id + '-block').addClass('viewed');
      }
    }

    $('#' + id.substr(1) + '-menu')
      .addClass('active')
      .addClass('current');

    if (location.hash !== hash) {
      location.hash = hash;
    }
  }

  $(".default_datepicker").datepicker({
    minDate: new Date("-1y"),
    dateFormat: "dd.mm.yy",
  });

  $(".empty_datepicker").datepicker({
    dateFormat: "dd.mm.yy",
  });

  $(".buttons a").on("click", function (event) {
    event.preventDefault();

    let block = $(this).attr('href').split('#')[1];
    $('.content-block').addClass('hidden-block');
    $('#' + block).removeClass('hidden-block', { duration: 200 });
  });

  function isValidPhone(phone) {
    return /^\+\d{6,17}$/.test(phone);
  }

  function isValidEmail(email, strict) {
    if (!strict) {
      email = email.replace(/^\s+|\s+$/g, '');
    }
    return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i.test(
      email
    );
  }

  function sendInvitePhone(phone, customer, reply, inEnglish, note, managerIds) {
    $.ajax({
      url: '/ajax/sendInvite',
      type: 'POST',
      data: {
        YII_CSRF_TOKEN: token,
        phone: phone,
        customer: customer,
        reply: reply,
        inEnglish: inEnglish,
        note: note,
        managerIds: managerIds
      }
    }).done(function(response) {
      response = JSON.parse(response);
      if (response.code == 0) {
        if (response.response.length) {
          location.href = response.response;
        } else {
          location.href = '/freelancers';
        }
      } else {
        location.href = '/freelancers';
      }
    });
  }

  function sendSmsInvite(phone, user) {
    $.ajax({
      url: '/ajax/sendSmsInvite',
      type: 'POST',
      data: {
        YII_CSRF_TOKEN: token,
        phone: phone,
        user: user
      }
    }).done(function(response) {
      response = JSON.parse(response);

      if (response.code == 0) {
        if (response.response.length) {
          location.href = response.response;
        } else {
          location.href = '/freelancers';
        }
      } else {
        let error =
          response.response !== undefined &&
          response.response.error !== undefined
            ? response.response.error
            : response.text;

        $('.errors').text(error);
        $('.errors').removeClass('hidden-block');
      }
    });
  }

  let sendInviteClicked = false;
  $('#send_invite').on('click', function() {
    if (sendInviteClicked != true) {
      sendInviteClicked = true;

      let phone = $('#invite_phone').val();
      let note = $('#invite_note').val();
      let customer = $('#customer').val();
      let inEnglish = $('#in_english:checked').val();
      let managerIds = $('#select-managers').val();

      $('.empty_customer').addClass('hidden-block');
      $('.empty_phone').addClass('hidden-block');
      $('.incorrect_phone').addClass('hidden-block');

      if (!phone.length) {
        $('.empty_phone').removeClass('hidden-block');
      } else {
        $('.empty_phone').addClass('hidden-block');

        if (!isValidEmail(phone)) {
          $('.incorrect_phone').removeClass('hidden-block');
        } else {
          $('.incorrect_phone').addClass('hidden-block');

          if (!customer.length) {
            $('.empty_customer').removeClass('hidden-block');
          } else {
            $('.empty_customer').addClass('hidden-block');
            $('#send_invite_text').addClass('hidden');
            if (showLoader($(this), $('#send_invite_loader'))) {
              sendInvitePhone(phone, customer, false, inEnglish, note, managerIds);
              return;
            }
          }
        }
      }

      sendInviteClicked = false;
    }
  });

  $('body').on('click', '.reply_invite_by_sms', function(event) {
    event.preventDefault();

    let user = $(this).data('user');
    $('#phoneRequestModal #sms-send-to-user').val(user);
    $('#phoneRequestModal').modal('show');
  });

  let sendSmsInviteClicked = false;
  $('#send_invite_by_sms').on('click', function() {
    if (sendSmsInviteClicked !== true) {
      sendSmsInviteClicked = true;

      let phone = $('#phone-request').val().replace(/\s/g, '');
      let user = $('#sms-send-to-user').val();
      if (phone.length === 0 || !isValidPhone(phone)) {
        $('.errors').text($('.errors').data('default'));
        $('.errors').removeClass('hidden-block');
      } else {
        $('.errors').addClass('hidden-block');
        $('#send_invite_by_sms_text').addClass('hidden');
        if (showLoader($(this), $('#send_invite_by_sms_loader'))) {
          sendSmsInvite(phone.replace(/\D/g, ''), user);
          return;
        }
      }

      sendSmsInviteClicked = false;
    }
  });

  $('body').on('click', '.reply_invite', function(event) {
    event.preventDefault();

    let user_id = $(this).data('user');

    showSpinner($(this));

    $.ajax({
      url: '/ajax/resendInvite',
      type: 'POST',
      data: {
        user: user_id,
        YII_CSRF_TOKEN: token
      }
    }).done(function(response) {
      response = JSON.parse(response);
      if (response.response.length) {
        location.href = response.response;
      } else {
        location.href = '/freelancers';
      }
    });
  });

  const onBalanceUpContinue = (isSuccess) => {
    const data = $('#topup_balance').serializeArray();
    const currency = data.find(el => el.name === 'currency').value;
    const payment_type = data.find(el => el.name === 'payment_type').value;
    let currencyAsStr;
    switch (currency) {
      case '1':
        currencyAsStr = 'rub';
        break;
      case '2':
        currencyAsStr = 'usd';
        break;
      default:
        currencyAsStr = 'eur';
        break;
    }
    const userIdEl = document.getElementById('userId');
    const userId = userIdEl ? userIdEl.content : '0';
    try {
      if (typeof window.ym === 'function') {
        window.ym(29709265, 'reachGoal', 'balance_topup', {
          status: isSuccess ? 'success' : 'closed',
          currency: currencyAsStr,
          payment_method: payment_type,
          user_id: userId
        });
      }
    } catch (_) {
    }
  };

  function format(d, count) {
    let compensationAmount = typeof d.compensationAmount !== 'undefined' ? d.compensationAmount : 0;

    let html = '<tr><td colspan="' + count + '">';

    html +=
      '<table class="table table-hover table-detail">' +
      '<tr>' +
      '<td style="width:120px">' +
      translate.task_title +
      ':</td>' +
      '<td>' +
      d.title +
      '</td>' +
      '</tr>' +
      '<tr>' +
      '<td>' +
      translate.task_description +
      ':</td>' +
      '<td class="editor-style">' +
      d.description +
      '</td>' +
      '</tr>';

    if (d.mtxid != undefined) {
      html +=
        "<tr>" +
        '<td style="width:120px">Merchant TxId:</td>' +
        "<td>" +
        (d.mtxid != undefined ? d.mtxid : "-") +
        "</td>" +
        "</tr>";
    }

    if (d.pmethod != undefined) {
      html +=
        "<tr>" +
        '<td style="width:120px">Payout Method:</td>' +
        "<td>" +
        (d.pmethod != undefined ? d.pmethod : "-") +
        "</td>" +
        "</tr>";
    }

    if (typeof d.group !== 'undefined') {
      html +=
        '<tr>' +
        '<td>' +
        translate.task_groups +
        ':</td>' +
        '<td>' +
        d.group +
        '</td>' +
        '</tr>';
    }

    html +=
      '<tr>' +
      ($.parseHTML(d.created)[0].innerHTML !== undefined ?
        '<td>' +
        translate.date_created +
        ':</td>' +
        '<td><strong>' +
        formatDateTime(parseInt($.parseHTML(d.created)[0].innerHTML) * 1000, true) +
        '</strong></td>' : '-') +
      '</tr>' +
      '<tr>' +
        '<td>' +
        translate.date_paid +
        ':</td>' +
        '<td><strong>' +
        ($.parseHTML(d.paid)[0].innerHTML !== undefined ? formatDateTime(parseInt($.parseHTML(d.paid)[0].innerHTML) * 1000, true) : '-') +
        '</strong></td>' +
      "<tr>" +
      "<td>" +
      translate.task_manager +
      ':</td>' +
      '<td>' +
      ($.parseHTML(d.manager)[0].innerHTML !== undefined ?
        formatDateTime(parseInt($.parseHTML(d.manager)[0].innerHTML) * 1000, true) + d.manager.split('>').pop() :
        '-') +
      '</td>' +
      '</tr>' +
      '<tr>' +
      '<td>' +
      translate.task_worker +
      ':</td>' +
      '<td>' +
      d.worker +
      '</td>' +
      '</tr>';

    if (d.payer != undefined) {
      html +=
        '<tr>' +
        '<td>' +
        translate.task_payer +
        ':</td>' +
        '<td>' +
        d.payer +
        '</td>' +
        '</tr>' +
        '<tr>';
    }

    if (typeof d.sum !== 'undefined') {
      html +=
        '<td>' +
        translate.sum_all +
        ":</td>" +
        '<td><i class="txt-color-blueLight">' +
        d.sum +
        "</i></td>" +
        "</tr>";
    }

    if (compensationAmount) {
      const parsedAmount = compensationAmount.replaceAll('>', '<').split('<');
      let hasAmountMoreThanZero = false;
      parsedAmount.map(el => hasAmountMoreThanZero = hasAmountMoreThanZero || (!!parseFloat(el)));
      let percentText = '';
      if (hasAmountMoreThanZero) {
        const currencyText = d.currency === '₽' ? 'rub' : (d.currency === '€' ? 'eur' : 'usd');
        percentText = d.compensationPercent > 0 ? ` • ${d.compensationPercent}%` : (' ' + translate[`small_compensation_${currencyText}`]);
      }

      html +=
        '<td>' +
        translate.compensationAmount +
        ":</td>" +
        '<td><i class="txt-color-blueLight">' + compensationAmount + percentText + "</i></td>" +
        "</tr>";
    }

    if (typeof d.advCommissionAmount !== 'undefined') {
      html +=
          "<td>" +
          translate.advCommissionAmount +
          ":</td>" +
          '<td><i class="txt-color-blueLight">' +
          d.advCommissionAmount +
          "</i></td>" +
          "</tr>";
    }

    if (typeof d.amount !== 'undefined') {
      html +=
        '<td>' +
        translate.amount +
        ":</td>" +
        '<td><i class="txt-color-blueLight">' +
        d.amount +
        "</i></td>" +
        "</tr>";
    }

    if (d.damage) {
      html +=
        '<td><span class="damage-table">' +
        translate.damage +
        '</span></td>' +
        '<td>' +
        d.damage +
        '</td>' +
        '</tr>';
    }

    if (d.acceptanceFiles) {
      html +=
          '<td><span>' +
          translate.acceptanceFiles +
          "</span></td>" +
          "<td>" +
          d.acceptanceFiles +
          "</td>" +
          "</tr>";
    }

    html += '</table></td></tr>';

    return html;
  }

  $("#elements-main").on("click", ".task-collapse",  function(event) {
    event.preventDefault();

    let that = $(this);
    let item = $(this).parents("tr");
    let tr = $(this).closest("tr");

    let data = {
      title: item.data("title"),
      description: item.data("description"),
      created: item.data("created"),
      paid: item.data("paid"),
      manager: item.data("manager"),
      payer: item.data("payer"),
      sum: item.data("sum"),
      amount: item.data("amount"),
      group: item.data("group"),
      mtxid: item.data("merchant-txid"),
      pmethod: item.data("payout-method"),
      worker: item.data("worker"),
      damage: item.data("damage"),
      acceptanceFiles: item.data("acceptance-files"),
      compensationAmount: item.data("compensation-amount"),
      compensationPercent: item.data("compensation-percent"),
      currency: item.data("currency"),
      advCommissionAmount: item.data('adv_commission_amount')
    };

    if (that.find("i").hasClass("fa-minus-circle")) {
      // This row is already open - close it
      tr.next("tr").remove();
      tr.removeClass("shown");
      that.find("i").removeClass("fa-minus-circle").addClass("fa-plus-circle");
    } else {
      // Open this row
      tr.after(format(data, tr.find("td").length));
      tr.addClass("shown");
      that.find("i").removeClass("fa-plus-circle").addClass("fa-minus-circle");
    }
  });

  $("#elements-main").on("click", '.row-collapse-link', function(event) {
    event.preventDefault();
    let that = $(this);
    let tr = $(this).closest('tr');

    if (that.find('i').hasClass('fa-minus')) {
      tr.next('tr').hide();
      tr.removeClass('shown');
      that.find('i').removeClass('fa-minus').addClass('fa-plus');
    } else {
      tr.next('tr').show();
      tr.addClass('shown');
      that.find('i').removeClass('fa-plus').addClass('fa-minus');
    }
  });

  $("#elements-main, #main-freelancer").on("click", ".sr-row-collapse-link",function(event) {
    event.preventDefault();
    let that = $(this);
    let tr = $(this).closest('tr');

    if (that.find('i').hasClass('fa-minus')) {
      tr.next('tr').hide();
      tr.removeClass('shown');
      that.find('i').removeClass('fa-minus').addClass('fa-plus');
    } else {
      tr.next('tr').show();
      tr.addClass('shown');
      that.find('i').removeClass('fa-plus').addClass('fa-minus');
    }
  });

  $(".select_checkboxes").on("click", function () {
    var target = $(this).data("target");
    var isChecked = $(this).prop("checked");

    if (isChecked) {
      $('input[type=checkbox].' + target + ':not(:checked)').trigger('click');
    } else {
      $('input[type=checkbox].' + target + ':checked').trigger('click');
    }
  });

  $('body').on('click', '[data-copy-text]', function(e) {
    e.preventDefault();
    let text = $(this).data('copy-text');
    window.prompt(translate.copy_text_title, text);
  });

  //Импорт задач и фрилов в ЛК заказчика
  $('#import-file-form button.btn-primary').on('click', function() {
    if (!$(this).hasClass('disabled')) {
      $('#import-file-form').trigger('submit');
    }
    $(this).addClass('disabled');
    $(this).attr('disabled', true);
  });

  $('input[type="checkbox"][data-toggle-button]').on(
    'change',
    function(event) {
      let $el = $(this);
      if ($el.prop('checked')) {
        $($el.attr('data-toggle-button')).each(function() {
          $(this)
            .prop('disabled', '')
            .removeClass('btn-default')
            .addClass('btn-primary');
        });
      } else {
        $($el.attr('data-toggle-button')).each(function() {
          $(this)
            .prop('disabled', 'disabled')
            .addClass('btn-default')
            .removeClass('btn-primary');
        });
      }
    }
  );

  $('#upgrade-first-form #continue-button').on('click', function(event) {
    let $el = $(this);

    if ($el.prop('disabled')) {
      return;
    }

    let val = $('input[name="go"]:checked', '#upgrade-first-form').val();

    if (val != 1) {
      event.preventDefault();
      document.location.href = $('#upgrade-first-form').attr('action');
      return false;
    }
  });

  if ($('.table-wrap').length) {
    $('.table-wrap').each(function() {
      let nmtTable = $(this);
      let nmtHeadRow = nmtTable.find('thead tr');

      nmtTable.find('tbody tr').each(function() {
        let curRow = $(this);
        for (let i = 0; i < curRow.find("td").length; i++) {
          let rowSelector = 'td:eq(' + i + ')';
          let headSelector = 'th:eq(' + i + ')';
          curRow
            .find(rowSelector)
            .attr('data-title', nmtHeadRow.find(headSelector).text());
        }
      });
    });
  }

  if ($('[data-toggle="tooltip"]').length) {
    $('[data-toggle="tooltip"]').tooltip();
  }

  // you can use only 2 classes .sr-box-trigger for trigger and .dynamic-hidden for hidden cells
  $('.sr-box-trigger').on('click',  function(e) {
    e.preventDefault();
    const thisParentTd = $(this).parents('tr');
    const sb = $(this).parent().siblings('.dynamic-hidden');

    const hiddenCells = Array.from(sb).map(function(it) {
      return `<div class='list-item'>${it.innerHTML}</div>`;
    });

    const joinArrData = hiddenCells.join('');

    const siblingsLength = $(this).parent('td').siblings().length + 1;

    const data = `<tr class="dynamic-box"><td colspan=${siblingsLength}>${joinArrData}</td></tr>`;

    thisParentTd.toggleClass('opened');

    if (thisParentTd.hasClass('opened')) {
      $(this)
        .children()
        .removeClass('fa-plus-circle')
        .addClass('fa-minus-circle');
      thisParentTd.after(data);
    } else {
      $(this)
        .children()
        .removeClass('fa-minus-circle')
        .addClass('fa-plus-circle');
      thisParentTd.next().remove();
    }
  });

  function onTaskMenuClick(type) {
    const userIdEl = document.getElementById('userId');
    const userId = userIdEl ? userIdEl.content : '0';
    try {
      if (typeof window.ym === 'function') {
        window.ym(29709265, 'reachGoal', 'tasks_task_status', { status_name: type, user_id: userId });
      }
    } catch (_) {
    }
  }

  $('#task-status-filter-all').on('click', () => {
    onTaskMenuClick('All');
  });
  $('#task-status-filter-acceptance').on('click', () => {
    onTaskMenuClick('Pending acceptance');
  });
  $('#task-status-filter-pay').on('click', () => {
    onTaskMenuClick('Pending payment');
  });
});

//Serializator
window.serialize = function(form) {
  let serialized = [];
  for (let i = 0; i < form.elements.length; i++) {
    let field = form.elements[i];
    if (
      !field.name ||
      field.disabled ||
      field.type === 'file' ||
      field.type === 'reset' ||
      field.type === 'submit' ||
      field.type === 'button'
    )
      continue;
    if (field.type === 'select-multiple') {
      for (let n = 0; n < field.options.length; n++) {
        if (!field.options[n].selected) continue;
        serialized.push(
          encodeURIComponent(field.name) +
          '=' +
          encodeURIComponent(field.options[n].value)
        );
      }
    } else if (
      (field.type !== 'checkbox' && field.type !== 'radio') ||
      field.checked
    ) {
      serialized.push(
        encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value)
      );
    }
  }

  return serialized.join('&');
};

/**
 * Show loader and checks in background if document is ready
 * @param selector - css selector for element where loading and download are shown
 * @param document_id
 * @param redirect
 */
function documentStatusWidget(selector, file_ids) {
  let dfd = jQuery.Deferred();
  // add loader
  $(selector).unbind();
  $(selector).html(
    '<i class="fa fa-refresh fa-spin fa-1x fa-fw"></i> ' +
    translate.generating_document
  );
  $(selector).show();

  getDocumentStatus(file_ids)
    .done(function(file_ids) {
      dfd.resolve(file_ids);
    })
    .fail(function(response) {
      dfd.reject(response);
    });

  return dfd.promise();
}

function getDocumentStatus(file_ids) {
  let dfd = jQuery.Deferred();
  $.post(
    '/ajax/getdocumentstatus',
    {
      YII_CSRF_TOKEN: token,
      file_ids: file_ids
    },
    function(response) {
      let JSONresponse = JSON.parse(response);
      if (JSONresponse.code == 0) {
        dfd.resolve(JSONresponse.response);
      } else {
        let currentInstance = this;
        setTimeout(function() {
          $.ajax(currentInstance);
        }, 1000);
      }
    }
  ).fail(function(response) {
    dfd.reject(response);
  });

  return dfd.promise();
}

/**
 * Function to format numbers with separators between thousands and delimiters
 * Similar to PHP function number_format
 * @param decimals
 * @param dec_separator
 * @param thousand_separator
 * @returns {string}
 */
Number.prototype.formatMoney = function(
  decimals,
  dec_separator,
  thousand_separator
) {
  let number = this;
  decimals = isNaN((decimals = Math.abs(decimals))) ? 2 : decimals;
  dec_separator = dec_separator == undefined ? ',' : dec_separator;
  thousand_separator =
    thousand_separator == undefined ? ' ' : thousand_separator;
  let s = number < 0 ? '-' : '';
  let i = parseInt((number = Math.abs(+number || 0).toFixed(decimals))) + '';
  let j = (j = i.length) > 3 ? j % 3 : 0;
  return (
    s +
    (j ? i.substr(0, j) + thousand_separator : '') +
    i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousand_separator) +
    (decimals
      ? dec_separator +
      Math.abs(number - i)
        .toFixed(decimals)
        .slice(2)
      : '')
  );
};
